import { useNavigate } from "react-router-dom";
import { TextField, Button, CardMedia, Input } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { ChangeEvent, useState } from "react";

const EditProfile = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Edit Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-profile")}>Manage Profile</button>
          {' '} - Edit Profile
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="bannerimage">Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={image}
                        alt="photo"
                      />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image"
                  htmlFor="icon-button-file"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(
                      event: ChangeEvent<HTMLInputElement>
                    ) => {
                      const files = (
                        event.target as HTMLInputElement
                      ).files;
                      if (
                        files &&
                        files[0].type.includes("image")
                      ) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage(
                          "This field only accepts images."
                        );
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="icon"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_33">
              <label htmlFor="name">Name</label>
              <TextField id="name" placeholder="Enter Name" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_33">
              <label htmlFor="email">Email Id</label>
              <TextField id="email" placeholder="Enter Email Id" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_33">
              <label htmlFor="phone">Phone Number</label>
              <TextField id="phone" placeholder="Enter Phone Number" hiddenLabel fullWidth></TextField>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary">Next</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
